/**
 * Takes an Array<V>, and a grouping function,
 * and returns a Map of the array grouped by the grouping function.
 *
 * @param list An array of type V.
 * @param keyGetter A Function that takes the Array type V as an input, and returns a value of type K.  
 *                  K is generally intended to be a property key of V.
 *
 * @returns Map of the array grouped by the grouping function.
 */
export const MapGroupBy = (list, keyGetter) => {
    return list.reduce((map, item) => {
        const key        = keyGetter(item);
        const collection = map.get(key);
        collection ? collection.push(item) : map.set(key, [item]);
        return map;
    }, new Map());
}

/**
 * 
 * @param {*} map Object map
 * @param {*} keys 
 * @return {[]} Return an array of values find by keys
 */
export const MapGetByKeys = (map, keys) => {
    keys = Array.isArray(keys) ? keys : [keys];

    return keys
        .filter(key => map.has(key))
        .flatMap(key => map.get(key))
    ;
}
